import { type FC } from 'react';
import { type OpenApiSchemaDashboardTodolistItem } from '#shared/api/schema';
import { DashboardTodoListContentLayout } from './components/DashboardTodoListContentLayout/DashboardTodoListContentLayout';
import { useDashboardTodoListContentModel } from './hooks/useDashboardTodoListContentModel';

export type DashboardTodoListContentProps = {
    items: OpenApiSchemaDashboardTodolistItem[];
    onToggleItemComplete: (item: OpenApiSchemaDashboardTodolistItem) => void;
    onMarkdownLinkClick: (params: { itemId: string; href: string }) => void;
    completingItemId: string | null;
};

export const DashboardTodoListContent: FC<DashboardTodoListContentProps> = ({
    items,
    onToggleItemComplete,
    onMarkdownLinkClick,
    completingItemId,
}) => {
    const model = useDashboardTodoListContentModel({ items, onToggleItemComplete });

    return (
        <DashboardTodoListContentLayout
            completingItemId={completingItemId}
            firstIncomplete={model.firstIncomplete}
            firstIncompleteFeatureHints={model.firstIncompleteFeatureHints}
            itemsCompleted={model.itemsCompleted}
            itemsToComplete={model.itemsToComplete}
            makeExpandToggle={model.makeExpandToggle}
            onMarkdownLinkClick={onMarkdownLinkClick}
            onToggleItemComplete={model.handleToggleItemCompleteAndCollapseOpen}
            openItemId={model.openItemId}
        />
    );
};
